var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShowPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.354,
    height: 20.461,
    viewBox: "0 0 11.354 20.461",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1849",
    transform: "translate(-944.278 -1134.075)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    cx: 1.55,
    cy: 1.55,
    r: 1.55,
    transform: "translate(948.216 1151.436)",
    fill: "#e30613"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    cx: 1.55,
    cy: 1.55,
    r: 1.55,
    transform: "translate(944.278 1134.075)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    cx: 1.55,
    cy: 1.55,
    r: 1.55,
    transform: "translate(944.278 1138.416)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    cx: 1.55,
    cy: 1.55,
    r: 1.55,
    transform: "translate(944.278 1142.755)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21",
    cx: 1.55,
    cy: 1.55,
    r: 1.55,
    transform: "translate(944.278 1147.096)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    cx: 1.55,
    cy: 1.55,
    r: 1.55,
    transform: "translate(948.216 1134.075)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    cx: 1.55,
    cy: 1.55,
    r: 1.55,
    transform: "translate(948.216 1138.416)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    cx: 1.55,
    cy: 1.55,
    r: 1.55,
    transform: "translate(948.216 1142.755)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20",
    cx: 1.55,
    cy: 1.55,
    r: 1.55,
    transform: "translate(948.216 1147.096)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    cx: 1.55,
    cy: 1.55,
    r: 1.55,
    transform: "translate(952.531 1134.075)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    cx: 1.55,
    cy: 1.55,
    r: 1.55,
    transform: "translate(952.531 1138.416)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    cx: 1.55,
    cy: 1.55,
    r: 1.55,
    transform: "translate(952.531 1142.755)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    cx: 1.55,
    cy: 1.55,
    r: 1.55,
    transform: "translate(952.531 1147.096)",
    fill: "#707070"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPhone);
export default __webpack_public_path__ + "static/media/show-phone.e1fb7a65b83c567591061c7ac69be3a0.svg";
export { ForwardRef as ReactComponent };